import { render, staticRenderFns } from "./ModuleDescribe.vue?vue&type=template&id=929eef92&scoped=true"
import script from "./ModuleDescribe.vue?vue&type=script&lang=js"
export * from "./ModuleDescribe.vue?vue&type=script&lang=js"
import style0 from "./ModuleDescribe.vue?vue&type=style&index=0&id=929eef92&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929eef92",
  null
  
)

export default component.exports